var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasContent
        ? _c("div", { staticClass: "content" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm.errorMessage
        ? _c("b-notification", { attrs: { type: "is-danger" } }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.errorMessage) } }),
          ])
        : _vm._e(),
      _vm.featureImage
        ? _c("div", [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "featured-image",
                class: { sorting: _vm.sortImages },
              },
              [
                _c("feature-image", {
                  staticClass: "featured-image-holder",
                  attrs: {
                    name: _vm.featureImage,
                    feature: true,
                    "on-delete": function () {
                      return _vm.deleteImage(0)
                    },
                  },
                }),
              ],
              1
            ),
            _c("hr"),
          ])
        : _vm._e(),
      _c("div", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c("div", { staticClass: "content" }, [
            !_vm.sortImages
              ? _c("h3", { staticClass: "title is-marginless" }, [
                  _vm._v(" Gallery images "),
                ])
              : _c("h3", { staticClass: "title is-marginless" }, [
                  _vm._v(" Drag n drop the images to change order "),
                ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "level-right" },
          [
            _c(
              "b-switch",
              {
                model: {
                  value: _vm.sortImages,
                  callback: function ($$v) {
                    _vm.sortImages = $$v
                  },
                  expression: "sortImages",
                },
              },
              [_vm._v("Sort images")]
            ),
          ],
          1
        ),
      ]),
      !_vm.sortImages
        ? _c("div", [
            _c(
              "div",
              { staticClass: "columns is-multiline" },
              [
                _vm._l(_vm.galleryImages, function (_name, index) {
                  return _c("gallery-image", {
                    key: index,
                    staticClass: "column is-4",
                    attrs: {
                      name: _name,
                      cropped: true,
                      size: "is-4by3",
                      "on-delete": function () {
                        return _vm.deleteImage(index + 1)
                      },
                    },
                  })
                }),
                _vm.progress
                  ? _c("div", { class: ["column", "is-4"] }, [
                      _c(
                        "progress",
                        {
                          staticClass: "dc-progress",
                          attrs: { max: "100" },
                          domProps: { value: _vm.progress },
                        },
                        [_vm._v(" " + _vm._s(_vm.progress) + "% ")]
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.galleryImages.length <= 8,
                        expression: "galleryImages.length <= 8",
                      },
                    ],
                    class: ["column", "is-4"],
                  },
                  [
                    _c("dropzone", {
                      ref: "dcGalleryDropzone",
                      class: { "is-active": _vm.galleryImages.length },
                      attrs: { id: _vm.name, options: _vm.options },
                      on: {
                        "vdropzone-error": _vm.uploadError,
                        "vdropzone-error-multiple": _vm.uploadError,
                        "vdropzone-success": _vm.success,
                        "vdropzone-total-upload-progress": _vm.upload,
                        "vdropzone-queue-complete": _vm.complete,
                      },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
            _vm.showError
              ? _c("p", { staticClass: "help is-danger" }, [
                  _vm._v(_vm._s(_vm.error)),
                ])
              : _vm._e(),
            _c("div", { staticClass: "my-preview" }),
          ])
        : _vm._e(),
      _vm.sortImages
        ? _c(
            "div",
            [
              _c(
                "draggable",
                {
                  staticClass: "columns is-multiline image-sorting",
                  attrs: { list: _vm.myFields, "ghost-class": "ghost" },
                  on: { end: _vm.end },
                },
                _vm._l(_vm.myFields, function (_name, index) {
                  return _c("gallery-image", {
                    key: index,
                    staticClass: "column is-4",
                    attrs: {
                      name: _name,
                      cropped: true,
                      size: "is-4by3",
                      sortable: "",
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("Featured image")]),
      _c("p", [
        _vm._v(
          " This is the main photo for your listing and will appear in search results. Choose a photo that makes a great first impression "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }